/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
import { Scenario } from '../scenario'
import { Scrollchor } from 'react-scrollchor'

// TODO Set the correct article ID here
const ARTICLE_ID = '135411084995'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>So viel kostet uns das CO₂-Gesetz</h1>
            <h2>
              Wir haben nachgerechnet, wie teuer ein Ja zum CO₂-Gesetz wäre.
              Sieben konkrete Beispiele für Familien, Paare und Einzelhaushalte.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Martin Läubli, Mathias Lutz</div>
            <div className='ta updated'>Aktualisiert am 8. Juni 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Es werden viele Zahlen herumgereicht, meistens sind sie nicht
              exakt nachvollziehbar. Auch auf der Website des Bundes ist nicht
              genau ersichtlich, wie viel Mehrkosten oder Einsparungen für
              einzelne Haushalte bei einer Annahme des CO₂-Gesetzes verursacht
              werden. Wir haben deshalb verschiedene Szenarien gemäss den
              Angaben des Bundesamtes für Umwelt (Bafu) durchgerechnet (siehe{' '}
              <Scrollchor to='#berechnungsgrundlage' className='scrollchor'>
                Berechnungsgrundlage
              </Scrollchor>
              ). Es wird zweifellos Gewinner und Verlierer geben. Verlieren
              wird, wer auf grossem Fuss lebt, ohne an ein nachhaltiges
              Verhalten zu denken. Die Berechnungen zeigen aber vor allem:
              Grundsätzlich ist das CO₂-Gesetz sozialverträglich, und die
              Zusatzkosten sind auf ein Jahr gerechnet moderat. Betroffen sind
              vor allem jene, die sich einen hohen Lebensstandard leisten können
              und dabei nicht auf klimaschonende Technologien setzen.
            </p>
            <p>
              Für einzelne Wirtschaftsbranchen haben wir keine
              Kostenberechnungen gemacht. Der Grund: Mit dem neuen CO₂-Gesetz
              können sich alle Schweizer Firmen– auch kleine KMU – von der
              CO₂-Abgabe entbinden lassen, wenn sie im Gegenzug bereit sind,
              ihren CO₂-Ausstoss zu vermindern. Heute sind nur einzelne Branchen
              zugelassen, sich von der CO₂-Abgabe zu befreien.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui container nomarg'>
          <div className='ui equal width stackable two column grid'>
            <div className='column'>
              <Scenario
                subtitle='Beispiel 1'
                title='Durchschnittliche vierköpfige Schweizer Familie'
                illustration={require('../../images/scenario1.svg')}
                heizung='Wohnung (128 m²) mit Ölheizung'
                auto='Jährliche Fahrleistung: 12’500 km'
                fliegen='1 Kurzstreckenflug pro Jahr'
              >
                <table className='ui very basic small unstackable celled table'>
                  <thead>
                    <tr>
                      <th>Kostenabrechnung</th>
                      <th>CHF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>CO₂-Abgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>1024 Liter</nobr> Heizöl extra leicht,{' '}
                          <nobr>56 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>573.–</td>
                    </tr>

                    <tr>
                      <td>Kompensationsaufschlag Treibstoff</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>760 Liter</nobr> Verbrauch,{' '}
                          <nobr>12 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>91.–</td>
                    </tr>
                    <tr>
                      <td>Flugticketabgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>4 x 30.–</div>
                      </td>
                      <td>120.–</td>
                    </tr>
                    <tr className='sumup'>
                      <td>
                        <div>Total Abgaben</div>
                      </td>
                      <td>723.–</td>
                    </tr>
                    <tr>
                      <td>
                        <div>Rückerstattung</div>
                      </td>
                      <td>668.–</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>4 x 167.–</nobr>
                        </div>
                      </td>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr className='red'>
                      <th>Mehrkosten pro Jahr</th>
                      <th>94.–</th>
                    </tr>
                  </tfoot>
                </table>
              </Scenario>
            </div>
            <div className='column'>
              <Scenario
                subtitle='Beispiel 2'
                title='Vierköpfige Familie mit hohem Lebensstandard und hohem Verbrauch'
                illustration={require('../../images/scenario2.svg')}
                heizung='Grosses Haus (200 m²) mit älterer Ölheizung'
                auto='Jährliche Fahrleistung (beide Eltern fahren mit dem Auto zur Arbeit): 44’000 Km'
                fliegen='1 Langstrecken- und 1 Kurzstreckenflug pro Jahr'
              >
                <table className='ui very basic small unstackable celled table'>
                  <thead>
                    <tr>
                      <th>Kostenabrechnung</th>
                      <th>CHF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>CO₂-Abgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>2500 Liter</nobr> Heizöl extra leicht,{' '}
                          <nobr>56 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>1400.–</td>
                    </tr>

                    <tr>
                      <td>Kompensationsaufschlag Treibstoff</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>2675 Liter</nobr> Verbrauch,{' '}
                          <nobr>12 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>321.–</td>
                    </tr>
                    <tr>
                      <td>Flugticketabgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>4 x 90.– und 4 x 30.–</div>
                      </td>
                      <td>480.–</td>
                    </tr>
                    <tr className='sumup'>
                      <td>
                        <div>Total Abgaben</div>
                      </td>
                      <td>2201.–</td>
                    </tr>
                    <tr>
                      <td>
                        <div>Rückerstattung</div>
                      </td>
                      <td>668.–</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr className='red'>
                      <th>Mehrkosten pro Jahr</th>
                      <th>1533.–</th>
                    </tr>
                  </tfoot>
                </table>
              </Scenario>
            </div>
            <div className='column'>
              <Scenario
                subtitle='Beispiel 3'
                title='Vierköpfige Familie mit tiefem Lebensstandard und mittlerem Verbrauch'
                illustration={require('../../images/scenario3.svg')}
                heizung='Wohnung (120 m²) mit Ölheizung'
                auto='Kein eigenes Auto'
                fliegen='Keine Flugreisen'
              >
                <table className='ui very basic small unstackable celled table'>
                  <thead>
                    <tr>
                      <th>Kostenabrechnung</th>
                      <th>CHF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>CO₂-Abgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>960 Liter</nobr> Heizöl extra leicht,{' '}
                          <nobr>56 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>538.–</td>
                    </tr>

                    <tr>
                      <td>Kompensationsaufschlag Treibstoff</td>
                      <td>0.–</td>
                    </tr>

                    <tr>
                      <td>Flugticketabgabe</td>
                      <td>0.–</td>
                    </tr>

                    <tr className='sumup'>
                      <td>
                        <div>Total Abgaben</div>
                      </td>
                      <td>538.–</td>
                    </tr>
                    <tr>
                      <td>
                        <div>Rückerstattung</div>
                      </td>
                      <td>668.–</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr className='green'>
                      <th>Einsparungen pro Jahr</th>
                      <th>130.–</th>
                    </tr>
                  </tfoot>
                </table>
              </Scenario>
            </div>

            <div className='column'>
              <Scenario
                subtitle='Beispiel 4'
                title='Einzelhaushalt mit hohem Lebensstandard und mittlerem Verbrauch'
                illustration={require('../../images/scenario4.svg')}
                heizung='Wohnung (80 m²) mit Wärmepumpe'
                auto='Kein Auto, Mobility-Mitglied, Mitfahrgelegenheiten: jährliche Fahrleistung 5000 Kilometer'
                fliegen='1 Langstrecken- und 1 Kurzstreckenflug pro Jahr'
              >
                <table className='ui very basic small unstackable celled table'>
                  <thead>
                    <tr>
                      <th>Kostenabrechnung</th>
                      <th>CHF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>CO₂-Abgabe</td>
                      <td>0.–</td>
                    </tr>
                    <tr>
                      <td>Kompensationsaufschlag Treibstoff</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>304 Liter</nobr> Verbrauch,{' '}
                          <nobr>12 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>36.–</td>
                    </tr>
                    <tr>
                      <td>Flugticketabgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>30.– und 90.–</div>
                      </td>
                      <td>120.–</td>
                    </tr>
                    <tr className='sumup'>
                      <td>
                        <div>Total Abgaben</div>
                      </td>
                      <td>156.–</td>
                    </tr>
                    <tr>
                      <td>
                        <div>Rückerstattung</div>
                      </td>
                      <td>167.–</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr className='green'>
                      <th>Einsparungen pro Jahr</th>
                      <th>11.–</th>
                    </tr>
                  </tfoot>
                </table>
              </Scenario>
            </div>
            <div className='column'>
              <Scenario
                subtitle='Beispiel 5'
                title='Einzelhaushalt mit mittlerem Lebensstandard und geringem Verbrauch'
                illustration={require('../../images/scenario5.svg')}
                heizung='Grosse Wohnung (100 m²) mit Wärmepumpe'
                auto='Kein eigenes Auto'
                fliegen='Alle zwei Jahre 1 Langstrecken- und 1 Kurzstreckenflug'
              >
                <table className='ui very basic small unstackable celled table'>
                  <thead>
                    <tr>
                      <th>Kostenabrechnung</th>
                      <th>CHF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>CO₂-Abgabe</td>
                      <td>0.–</td>
                    </tr>

                    <tr>
                      <td>Kompensationsaufschlag Treibstoff</td>
                      <td>0.–</td>
                    </tr>
                    <tr>
                      <td>Flugticketabgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          90.– und 30.– alle zwei Jahre
                        </div>
                      </td>
                      <td>60.–</td>
                    </tr>
                    <tr className='sumup'>
                      <td>
                        <div>Total Abgaben</div>
                      </td>
                      <td>60.–</td>
                    </tr>
                    <tr>
                      <td>
                        <div>Rückerstattung</div>
                      </td>
                      <td>167.–</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr className='green'>
                      <th>Einsparungen pro Jahr</th>
                      <th>107.–</th>
                    </tr>
                  </tfoot>
                </table>
              </Scenario>
            </div>

            <div className='column'>
              <Scenario
                subtitle='Beispiel 6'
                title='Einzelhaushalt mit hohem Lebensstandard und hohem Verbrauch'
                illustration={require('../../images/scenario6.svg')}
                heizung='Grosse Wohnung (100 m²) mit Ölheizung'
                auto='Jährliche Fahrleistung: 25’000 Kilometer'
                fliegen='2 Langstreckenflüge pro Jahr'
              >
                <table className='ui very basic small unstackable celled table'>
                  <thead>
                    <tr>
                      <th>Kostenabrechnung</th>
                      <th>CHF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>CO₂-Abgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>800 Liter</nobr> Heizöl extra leicht,{' '}
                          <nobr>56 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>448.–</td>
                    </tr>
                    <tr>
                      <td>Kompensationsaufschlag Treibstoff</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>1520 Liter</nobr> Verbrauch,{' '}
                          <nobr>12 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>182.–</td>
                    </tr>
                    <tr>
                      <td>Flugticketabgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>2 x 90.–</div>
                      </td>
                      <td>180.–</td>
                    </tr>
                    <tr className='sumup'>
                      <td>
                        <div>Total Abgaben</div>
                      </td>
                      <td>810.–</td>
                    </tr>
                    <tr>
                      <td>
                        <div>Rückerstattung</div>
                      </td>
                      <td>167.–</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr className='red'>
                      <th>Mehrkosten pro Jahr</th>
                      <th>643.–</th>
                    </tr>
                  </tfoot>
                </table>
              </Scenario>
            </div>
            <div className='column'>
              <Scenario
                subtitle='Beispiel 7'
                title='Paarhaushalt mit hohem Lebensstandard und tiefem Verbrauch'
                illustration={require('../../images/scenario7.svg')}
                heizung='Grosse Wohnung (200 m²) mit Wärmepumpe'
                auto='Jährliche Fahrleistung: Benziner (15’000 km) und Elektroauto'
                fliegen='Alle zwei Jahre ein Langstreckenflug'
              >
                <table className='ui very basic small unstackable celled table'>
                  <thead>
                    <tr>
                      <th>Kostenabrechnung</th>
                      <th>CHF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>CO₂-Abgabe</td>
                      <td>0.–</td>
                    </tr>
                    <tr>
                      <td>Kompensationsaufschlag Treibstoff</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>
                          <nobr>912 Liter</nobr> Verbrauch,{' '}
                          <nobr>12 Rappen</nobr> pro Liter
                        </div>
                      </td>
                      <td>109.–</td>
                    </tr>
                    <tr>
                      <td>Flugticketabgabe</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr className='indented'>
                      <td>
                        <div className='content'>2 x 90.– alle zwei Jahre</div>
                      </td>
                      <td>90.–</td>
                    </tr>
                    <tr className='sumup'>
                      <td>
                        <div>Total Abgaben</div>
                      </td>
                      <td>199.–</td>
                    </tr>
                    <tr>
                      <td>
                        <div>Rückerstattung</div>
                      </td>
                      <td>334.–</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr className='green'>
                      <th>Einsparungen pro Jahr</th>
                      <th>135.–</th>
                    </tr>
                  </tfoot>
                </table>
              </Scenario>
            </div>
            <div className='column'>&nbsp;</div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='berechnungsgrundlage'>
        <div className='ui text container'>
          <div className='ta text'>
            <h5>Berechnungsgrundlage</h5>
            <p>
              Wir haben uns strikte an die Annahmen des Bundes und die
              Vorschläge des Bundesrates gehalten – und jeweils die
              höchstmöglichen Zusatzbeiträge für 2030 verwendet, obwohl die
              maximalen Abgaben des aktuellen CO₂-Gesetzes bisher nie erreicht
              wurden. Bei den Verbrauchszahlen (Heizöl und Treibstoff) haben wir
              vereinfacht jeweils die durchschnittlichen Werte{' '}
              <Link href='https://www.bafu.admin.ch/bafu/de/home/themen/klima/dossiers/klimaschutz-und-co2-gesetz/kosten-des-revidierten-co2-gesetzes-fuer-eine-durchschnittsfamilie.html'>
                gemäss Bafu
              </Link>{' '}
              für die Schweiz verwendet: 8 Liter Heizöl extraleicht pro
              Quadratmeter Wohnfläche; 6,08 Liter Treibstoff pro 100 Kilometer
              (Diesel und Benziner).
            </p>
            <strong>CO₂-Abgabe auf Brennstoff</strong>
            <p>
              Heute 96 Franken, maximal 120 Franken. CO₂-Gesetz: maximal 210
              Franken pro Tonne CO₂. Auf einen Liter Heizöl umgerechnet: etwa 56
              Rappen pro Liter.
            </p>
            <strong>Flugticketabgabe</strong>
            <p>
              30 Franken für einen Kurzstreckenflug, 60 Franken für einen
              Mittelstreckenflug, 90 für einen Langstreckenflug. Dazu kommt ein
              zusätzlicher Aufschlag von 30 Franken für alle Premium-Klassen.
            </p>
            <strong>Kompensationsaufschlag auf Treibstoffe</strong>
            <p>Maximal 12 Rappen pro Liter Treibstoff.</p>
            <strong>
              Jährliche Rückerstattungen pro Kopf an die Bevölkerung über die
              Krankenkasse
            </strong>
            <p>
              ⅔ der CO₂-Abgabe wird rückerstattet. 2020 betrug die
              Rückerstattung 87 Franken pro Kopf. Mit dem CO₂-Gesetz kommen
              zusätzlich etwa 20 Franken hinzu. Insgesamt also 107 Franken. Bei
              der Flugzeugrückgabe rechnet man pro Kopf mit etwa 60 Franken. Die
              Rückerstattung beträgt also insgesamt, unabhängig davon, wie viel
              man mit dem Auto oder Flugzeug unterwegs ist: 167 Franken pro
              Kopf. Eine vierköpfige Familie erhält gemäss neuem CO₂-Gesetz etwa
              668 Franken.
            </p>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text & Beispielrechnungen', 'Martin Läubli'],
          ['Digitale Umsetzung', 'Mathias Lutz']
        ]}
      />
    </div>
  )
}
